<template>
  <div>
    <span
      class="badge"
      :class="badge.class"
    >
      <i 
        class="fa mr-2"
        :class="badge.icon"
      />
      {{ badge.text }}
    </span>
    <span
      v-if="status === 0"
      class="badge badge-primary"
    >
      Tahap {{ tahap }}
    </span>
  </div>
</template>
<script>
export default {
  props: {
    role: {
      type: String,
      default: () => null
    },
    status: {
      type: Number,
      default: () => null
    },
    tahap: {
      type: Number,
      default: () => null
    }
  },
  data () {
    return {
      badge: {
        class: '',
        icon: '',
        text: ''
      }
    }
  },
  mounted () {
    this.getBadge()
  },
  methods: {
    getBadge () {
      const textPenduduk = [
        'Belum Diajukan',
        'Diajukan ke Desa',
        'Diproses di Desa',
        'Revisi Tingkat Desa',
        'Ditolak Desa',
        'Diajukan ke Kecamatan',
        'Diproses di Kecamatan',
        'Revisi Tingkat Kecamatan',
        'Ditolak Kecamatan',
        'Diajukan ke Dukcapil',
        'Diproses di Dukcapil',
        'Revisi Tingkat Dukcapil',
        'Ditolak Dukcapil',
        'Dibatalkan',
        'Valid Dukcapil',
        'Berkas Siap',
        'Selesai'
      ]
      const textDesa = [
        'Belum Diajukan',
        'Belum Diproses',
        'Sedang Diproses',
        'Revisi',
        'Ditolak',
        'Valid',
        'Diproses di Kecamatan',
        'Revisi Tingkat Kecamatan',
        'Ditolak Kecamatan',
        'Diajukan ke Dukcapil',
        'Diproses di Dukcapil',
        'Revisi Tingkat Dukcapil',
        'Ditolak Dukcapil',
        'Dibatalkan',
        'Valid Dukcapil',
        'Berkas Siap',
        'Selesai'
      ]
      const textKecamatan = [
        'Belum Diajukan',
        'Diajukan ke Desa',
        'Diproses di Desa',
        'Revisi Tingkat Desa',
        'Ditolak Desa',
        'Belum Diproses',
        'Sedang Diproses',
        'Revisi',
        'Ditolak',
        'Valid',
        'Diproses di Dukcapil',
        'Revisi Tingkat Dukcapil',
        'Ditolak Dukcapil',
        'Dibatalkan',
        'Valid Dukcapil',
        'Berkas Siap',
        'Selesai'
      ]
      const textDukcapil = [
        'Belum Diajukan',
        'Diajukan ke Desa',
        'Diproses di Desa',
        'Revisi Tingkat Desa',
        'Ditolak Desa',
        'Diajukan ke Kecamatan',
        'Diproses di Kecamatan',
        'Revisi Tingkat Kecamatan',
        'Ditolak Kecamatan',
        'Belum Diproses',
        'Sedang Diproses',
        'Revisi',
        'Ditolak',
        'Dibatalkan',
        'Valid',
        'Berkas Siap',
        'Selesai'
      ]


      const badge = [
        ['badge-danger', 'fa-info-circle'],
        ['badge-danger', 'fa-info-circle'],
        ['badge-warning', 'fa-check-circle'],
        ['badge-warning', 'fa-info-circle'],
        ['badge-danger', 'fa-info-circle'],
        ['badge-danger', 'fa-info-circle'],
        ['badge-warning', 'fa-check-circle'],
        ['badge-warning', 'fa-info-circle'],
        ['badge-danger', 'fa-info-circle'],
        ['badge-danger', 'fa-info-circle'],
        ['badge-warning', 'fa-check-circle'],
        ['badge-warning', 'fa-info-circle'],
        ['badge-danger', 'fa-info-circle'],
        ['badge-danger', 'fa-info-circle'],
        ['badge-success', 'fa-check-circle'],
        ['badge-success', 'fa-check-circle'],
        ['badge-success', 'fa-check-circle']
      ]
      if (this.role === 'Penduduk') {
        this.badge.text = textPenduduk[this.status]
      } else if (['Operator Desa', 'Kepala Desa', 'Rumah Sakit'].includes(this.role)) {
        this.badge.text = textDesa[this.status]
      } else if (this.role === 'Operator Kecamatan') {
        this.badge.text = textKecamatan[this.status]
      } else if (this.role === 'Operator Dukcapil' || this.role === 'Operator Dukcapil Kecamatan' || this.role === 'Admin Laksita' || this.role === 'Admin Jembrana') {
        this.badge.text = textDukcapil[this.status]
      }
      this.badge.class = badge[this.status][0]
      this.badge.icon = badge[this.status][1]
    }
  }
}
</script>